module.exports = __webpack_public_path__ + "img/apidays-live-hongkong-2020agenda.f395aae1.png";